import React, { Suspense, useEffect, useMemo } from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "./Components/404/NotFound";
import ProtectedRoute from "./ShearedComponents/ProtectedRoute";
import routes from "./ShearedComponents/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const AllRoutes = () => {
  const { t, i18n } = useTranslation();

  const isRTL = useMemo(() => {
    const rtlLanguages = ["ar"];
    return rtlLanguages.includes(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
  }, [i18n.language, isRTL]);

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={isRTL}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <Routes>
          {routes.map(
            (
              { path, element: Element, protected: isProtected, seller },
              index
            ) => (
              <Route
                key={index}
                path={path}
                element={
                  isProtected ? (
                    <ProtectedRoute sellerOnly={seller}>
                      <Element />
                    </ProtectedRoute>
                  ) : (
                    <Element />
                  )
                }
              />
            )
          )}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default AllRoutes;
